<template>
  <div id="navigation">
    <button class="btn btn-default" v-on:click="toggleMenu">
      <span id="mobm">
        <div class="con">
          <div class="bar top"></div>
          <div class="bar middle"></div>
          <div class="bar bottom"></div>
        </div>
      </span>
    </button>

    <div id="menu">
      <div id="menu-inner">
        <h4 id="title">Thomas van Krugten</h4>

        <ul id="contact">
          <li v-if="data['.key'] == 'contact'" v-for="data, index in basic" :key="index">{{data.phone}}</li>
          <li v-if="data['.key'] == 'contact'" v-for="data, index in basic" :key="index">{{data.email}}</li>
          <li><a href="https://vimeo.com/thomasvankrugten" target="_blank">vimeo.com/thomasvankrugten</a></li>
        </ul>

        <span id="separator"></span>

        <ul id="main-nav">
          <router-link to="work" tag="li">
            <a>Work</a>
          </router-link>
          <router-link to="bio" tag="li">
            <a>Bio</a>
          </router-link>
        </ul>

      </div>
    </div>

  </div>
</template>

<script>
import {db} from '../firebase'

export default {
  name: 'navigation',
  data () {
    return {
      basic: Array
    }
  },
  firebase: {
    basic: {
      source: db.ref('basic'),
      cancelCallback (err) {
        console.error(err)
      }
    },
    work: {
      source: db.ref('projects').orderByChild('weight'),
      cancelCallback (err) {
        console.error(err)
      }
    },
    bio: {
      source: db.ref('bio'),
      cancelCallback (err) {
        console.error(err)
      }
    },
    stills: {
      source: db.ref('stills').orderByChild('weight'),
      cancelCallback (err) {
        console.error(err)
      }
    }
  },
  methods: {
    toggleMenu () {
      let html = document.querySelector('html')
      let body = document.querySelector('body')
      let nav = document.querySelector('#navigation')

      if (html.classList.contains('locked') && body.classList.contains('locked') && nav.classList.contains('show')) {
        html.classList.remove('locked')
        body.classList.remove('locked')
        nav.classList.remove('show')
      } else {
        html.classList.add('locked')
        body.classList.add('locked')
        nav.classList.add('show')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
html.locked,
body.locked {
  overflow: hidden!important;
}
</style>

<style scoped>
  #navigation {
    position: absolute;
    top: 40px;
    right: 50px;
    z-index: 3;
  }

  @media only screen and (max-width: 768px) {
    #navigation {
      right: 20px;
    }
  }

  #menu {
    position: fixed;
    right: -100%;
    top: 0;
    width: 320px;
    height: 100vh;
    z-index: 2;
    transition: all .7s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  .show #menu {
    right: 0;
    background: rgba(0, 0, 0, 0.85);
    transition: all .7s cubic-bezier(0.645, 0.045, 0.355, 1);

  }

  #menu-inner {
    position: absolute;
    top: 50%;
    width:230px;
    right:45px;
    transform: translate(0, -50%);

  }

  @media only screen and (max-width: 400px) {
    #menu {
      width: 100%;
    }

    #menu-inner{
      right: 50%;
      transform:translate(50%,-50%);
    }
  }

  #menu-inner #title {
    font-size: 24px;
  }

  h4#title{
    font-weight:bold;
  }

  #menu-inner ul {
    list-style: none!important;
    margin: 40px 0 0;
    padding: 0;
  }

  #menu-inner #contact {
    margin-top: 20px;
    margin-bottom: 40px;
  }

  #menu-inner #main-nav li:last-of-type {
    margin-top: 20px;
  }

  #main-nav {
       text-align: center;
  }

  #menu-inner li a {
    color: #fff;
    opacity:1;
  }

  #menu-inner li a:hover{
    text-decoration:none;
    font-weight: 700;
  }

  #menu-inner #main-nav li a {
    text-transform: uppercase;
    letter-spacing: 6px;
    font-size: 14px;
    line-height: 23px;
  }

  #separator {
    height: 1px;
    background: #fff;
    width: 40px;
    margin: 0 auto;
    display: block;
  }

  button {
    background: none;
    border: 0;
    color: #fff;
    outline: none!important;
    position: relative;
    z-index: 3;
    padding: 0;
    border-radius: 0;
    box-shadow: none!important;
    cursor: pointer;
  }

  .mobm {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .con {
    width: auto;
  }

  .con .bar {
    height: 1px;
    background: #fff;
    transition: all 0.5s ease;
    margin: 8px auto;
    width: 40px;
  }

  .con .bar.middle {
    width: 27px;
    margin: 8px 0;
  }

  .show .con .bar.top {
    -webkit-transform: translateY(9px) rotateZ(45deg);
    -moz-transform: translateY(9px) rotateZ(45deg);
    -ms-transform: translateY(9px) rotateZ(45deg);
    -o-transform: translateY(9px) rotateZ(45deg);
    transform: translateY(9px) rotateZ(45deg);
    width: 35px;
  }

  .show .con .bar.middle {
    width: 0;
    margin: 0 auto;
  }

  .con .bar.bottom {
    width: 33px;
    margin: 8px 0;
  }

  .show .con .bar.bottom {
    -webkit-transform: translateY(-9px) rotateZ(-45deg);
    -moz-transform: translateY(-9px) rotateZ(-45deg);
    -ms-transform: translateY(-9px) rotateZ(-45deg);
    -o-transform: translateY(-9px) rotateZ(-45deg);
    transform: translateY(-9px) rotateZ(-45deg);
    width: 35px;
  }

</styles>



// WEBPACK FOOTER //
// Navigation.vue?ef3c1e00